const createService = {
  select: 'Select',
  step0: 'Select the Equipment',
  step1: 'Select the Service Type',
  step2: 'Complete the Checklist',
  draftListTitle: 'Service Drafts',
  draftListDescription: 'There are similar services already started and not finished for this equipment',
  draftListButton: 'VIEW',
  toastrSucessDeleteDraftTitle: 'Draft deleted successfully',
  toastrErrorDeleteDraftTitle: 'Error deleting draft',
  savingDraft: 'Saving Draft...',
  lastSavedDraft: 'Last saved Draft' 
};

export default createService;